import api from '@/api'

export default {
  isSecured: false,
  baseUrl: '//localhost/git/october/taps/api/',
  getCarousel () {
    return api({
      url: '/carousel',
      method: 'get'
    })
  },
  getCustomerGroup () {
    return api({
      url: '/customergroup',
      method: 'get'
    })
  },
  getInventoryById (id) {
    return api({
      url: '/inventory/' + id,
      method: 'get'
    })
  },
  getInventory () {
    return api({
      url: '/inventory',
      method: 'get'
    })
  },
  getBeer (number, data) {
    let url = '/beer'
    if (number) {
      url = url + '?page=' + number
    }
    return api({
      url,
      method: 'post',
      data
    })
  },
  // getBeerById (data) {
  //   return api({
  //     url: '/beer/' + data.id,
  //     method: 'post',
  //     data
  //   })
  // },
  getBrands (data) {
    return api({
      url: '/brands',
      method: 'get'
    })
    // return api({
    //   url: '/brands',
    //   method: 'post',
    //   data
    // })
  },
  getStyles () {
    return api({
      url: '/style',
      method: 'get'
    })
  },
  getCountry () {
    return api({
      url: '/country',
      method: 'get'
    })
  },
  getPromotionById (id) {
    return api({
      url: '/promotion/' + id,
      method: 'get'
    })
  },
  getPromotions (data) {
    return api({
      url: '/allpromotions',
      method: 'post',
      data
    })
  },
  getAddressByUserId (id) {
    return api({
      url: '/useraddress/' + id,
      method: 'get'
    })
  },
  createAddress (data) {
    return api({
      url: '/useraddress',
      method: 'post',
      data
    })
  },
  updateAddress (data) {
    return api({
      url: '/useraddress/' + data.id + '/update',
      method: 'post',
      data
    })
  },
  getUserOrdersById (number, data) {
    let url = '/user/orders'
    if (number) {
      url = url + '?page=' + number
    }
    return api({
      url,
      method: 'post',
      data
    })
  },
  createOrder (data) {
    return api({
      url: '/order/create',
      method: 'post',
      data
    })
  },
  emailOrder (data) {
    return api({
      url: '/order/email',
      method: 'post',
      data
    })
  },
  getUserOrderById (data) {
    return api({
      url: '/user/order',
      method: 'post',
      data
    })
  },
  getCreditById (id) {
    return api({
      url: '/credits/' + id,
      method: 'get'
    })
  },
  getUserProfile (data) {
    return api({
      url: '/userprofile',
      method: 'post',
      data
    })
  },
  createMessage (data) {
    return api({
      url: '/message',
      method: 'post',
      data
    })
  },
  getGstRate (data) {
    return api({
      url: '/gstrate',
      method: 'post',
      data
    })
  },
  updateOrder (data) {
    return api({
      url: '/order/update',
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/site.js